<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';

defineProps({
    cancelIcon: {
        type: Boolean,
        required: false,
    },
    mobileOnly: {
        type: Boolean,
        required: false,
    },
    hideFromDesktop: {
        type: Boolean,
        required: false,
    },
    clickOff: {
        type: Boolean,
        required: false,
    },
});

const router = useRouter();

const hasPreviousHistory = computed(() => {
    return router.options.history.state.back !== null && router.options.history.state.back !== '';
});

function handleBack() {
    if (hasPreviousHistory.value) {
        router.back();
    } else {
        router.replace({ name: 'feed' });
    }
}

</script>

<template>
    <app-icon-button v-if="mobileOnly ? $store.state.deviceType === 'mobile' : (hideFromDesktop ? $store.state.deviceType !== 'desktop' : true)"
        :icon="cancelIcon ? 'cancel' : 'arrow-back'" @click="clickOff ? null : handleBack()"
        class="-ml-4" />
</template>
